import React from 'react';
import i18n from 'i18next';
import { VippedPage } from '../../components/Views/VippedPage';
import { getSeoData } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { getFilterVariantsForVipPage } from '../../api/queries';
import { getStaticData } from '../../utils/helpers/getStaticData';
import {
  getVippedBreadcrumbs,
  parseVippedFiltersFromQuery
} from '../../utils/helpers/vipped';

const Vipped = props => <VippedPage {...props} />;

Vipped.getInitialProps = async ({ apolloClient, asPath, req, query }) => {
  const adaptFilter = parseVippedFiltersFromQuery(query);
  const isBaseVipPage = !Object.keys(adaptFilter).length;

  try {
    const [filterVariantsForVipPage, seoData, staticData] = await Promise.all([
      apolloClient.query({ query: getFilterVariantsForVipPage }),
      getSeoData(apolloClient, asPath, req),
      getStaticData(apolloClient)
    ]);

    const { breadcrumbs, currAdaptFilter } = getVippedBreadcrumbs(
      filterVariantsForVipPage?.data,
      adaptFilter
    );

    return {
      seoData,
      breadcrumbs,
      isBaseVipPage,
      adaptFilter: currAdaptFilter,
      ...staticData
    };
  } catch (error) {
    console.error('Error fetching data:', error);

    return {
      isBaseVipPage,
      adaptFilter,
      breadcrumbs: [],
      seoData: {},
      keywords: [],
      categories: [],
      citiesUnPopularList: [],
      regions: {},
      ssrError: true
    };
  }
};

Vipped.getLayout = page => (
  <Layout
    noBorder
    isShowBackButton
    isBottomNavigation
    hideMobileHeader
    headerTitle={i18n.t('sections.vipped.title')}
  >
    {page}
  </Layout>
);

export default Vipped;
